import React from 'react';

import { About } from './About/About';
import { Services } from './Services/Services';
// import { CaseHistory } from './CaseHistory/CaseHistory'; /* AGGIUNGERE A SETTEMBRE */
import { Consulency } from './Consulency/Consulency';
import { Contacts } from './Contacts/Contacts';
import { People } from './People/People';
import { WorkWith } from './WorkWith/WorkWith';
import { Partners } from './About/Partners';
import { Divider } from '../../shared/components/Divider';

export const Sections = () => (
  <>
    <Divider height={100} />
    <About />
    <Divider height={100} />
    <Partners />
    <Divider height={100} />
    <WorkWith />
    <Divider height={100} />
    <Services />
    {/* <Divider height={100} />
    <CaseHistory /> */}
    <Divider height={100} />
    <Consulency />
    <Divider height={100} />
    <People />
    <Divider height={100} />
    <Contacts />
  </>
);
